import * as React from 'react';
import {
  TouchableOpacity,
  StyleSheet,
  GestureResponderEvent,
  View,
} from 'react-native';
import {Menu} from 'react-native-paper';
import Styles from '../Styles';

type TooltipState = {
  open: boolean;
  menuCoordinates: {
    x: number;
    y: number;
  };
};

interface TooltipProps {
  popover: React.ReactNode;
  children: React.ReactNode;
  width: number;
  backgroundColor: string;
  title?: string;
  accessible?: boolean;
  accessibilityRole?: string;
}

class Tooltip extends React.Component<TooltipProps, TooltipState> {
  constructor(props: TooltipProps) {
    super(props);
    this.state = {
      open: false,
      menuCoordinates: {
        x: 0,
        y: 0,
      },
    };
    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  toggleTooltip(event?: GestureResponderEvent) {
    const {nativeEvent} = event;
    if (nativeEvent) {
      this.setState((prevState) => {
        return {
          open: !prevState.open,
          menuCoordinates: {
            x: nativeEvent.pageX,
            y: nativeEvent.pageY,
          },
        };
      });
    }
  }

  render() {
    return (
      <View
        accessible={false}
        onAccessibilityEscape={this.toggleTooltip}
        accessibilityLabel={`${this.props.title}`}
        accessibilityHint={'reads the title of the current screen'}
        accessibilityRole={'header'}
      >
        <Menu
          visible={this.state.open}
          onDismiss={this.toggleTooltip}
          contentStyle={[
            styles.container,
            {
              backgroundColor: this.props.backgroundColor,
              maxWidth: this.props.width,
            },
          ]}
          anchor={this.state.menuCoordinates}
        >
          {this.props.popover}
        </Menu>
        <TouchableOpacity
          accessible={true}
          accessibilityRole={'header'}
          onPress={this.toggleTooltip}
        >
          {this.props.children}
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    padding: Styles.Spacing.m2,
    borderRadius: Styles.Spacing.m2,
  },
});
export default Tooltip;
